<ng-container *transloco="let t;">
  <form (submit)="onSubmit()" novalidate *ngIf="order !== null">

    <div class="p-grid">
        <div class="p-col-6">
            <h2>{{ t('common.labels.basedata') }}</h2>
        </div>
        <div class="p-col-6 p-text-right" *ngIf="inEdit !== true">
            <button withRight="admin.toolboxcandidate.edit" pButton (click)="onEdit()" type="button" label="{{ t('common.labels.edit') }}" icon="pi pi-pencil" class="p-button-sm p-mb-2 autofocus" [disabled]="order.basedata_editable ? null : true"></button>
            <button *ngIf="items.length > 0" pButton type="button" (click)="menu.toggle($event)" icon="pi pi-bars" class="p-button-outlined p-button-secondary p-button-sm p-mb-2 p-ml-2" aria-label="{{ t('common.labels.more_functions') }}"></button>
            <p-menu #menu [popup]="true" [model]="items"></p-menu>
        </div>
        <div class="p-col-6 p-text-right" *ngIf="inEdit === true">
          <app-form-buttons [submitting]="submitting" (cancelled)="onCancel()"></app-form-buttons>
        </div>
    </div>

    <app-loader [loading]="loading"></app-loader>

    <ng-container *ngIf="loading !== true">
      <div class="p-grid p-fluid">
          <div class="p-col-12 p-md-4">
            <app-form-control [cid]="'businessunit'" [control]="form.get('businessunit')" [type]="'group'" [options]="optionsBusinessunits" [filterBy]="'label'" [label]="t('common.labels.businessunit')" [edit]="inEdit" [basevalue]="order.businessunit.name"></app-form-control>
          </div>
          <div class="p-col-12 p-md-4">
            <app-form-control [cid]="'onlinetest'" [control]="form.get('onlinetest')" [type]="'group'" [options]="optionsPartners" [filterBy]="'label'" [label]="t('common.labels.testtype')" [edit]="inEdit" [basevalue]="order.onlinetest.name"></app-form-control>
          </div>
          <div class="p-col-12 p-md-4">
            <app-form-control [cid]="'language'" [control]="form.get('language')" [type]="'select'" [options]="optionsLanguages" [label]="t('common.labels.language')" [edit]="inEdit" [basevalue]="t(LANGUAGES[order.language])"></app-form-control>
          </div>
      </div>

      <hr>

      <h2>{{ t('common.labels.toolbox-candidate') }}</h2>
      <div class="p-grid p-fluid">
        <div class="p-col-12 p-md-4">
          <app-form-control [cid]="'gender'" [control]="form.get('candidate.gender')" [type]="'select'" [options]="optionsSalutations" [label]="t('common.labels.salutation')" [edit]="inEdit" [basevalue]="(order.gender) ? t('common.labels.' + order.gender) : '-'"></app-form-control>
        </div>
        <div class="p-col-12 p-md-4">
          <app-form-control [cid]="'firstname'" [control]="form.get('candidate.firstname')" [type]="'input'" [label]="t('common.labels.firstname')" [edit]="inEdit" [basevalue]="order.firstname"></app-form-control>
        </div>
        <div class="p-col-12 p-md-4">
          <app-form-control [cid]="'lastname'" [control]="form.get('candidate.lastname')" [type]="'input'" [label]="t('common.labels.lastname')" [edit]="inEdit" [basevalue]="order.lastname"></app-form-control>
        </div>
        <div class="p-col-12 p-md-4">
          <app-form-control [cid]="'email'" [control]="form.get('candidate.email')" [type]="'input'" [label]="t('common.labels.email')" [edit]="inEdit" [basevalue]="order.email"></app-form-control>
        </div>
        <div class="p-col-12 p-md-4">
          <app-form-control [cid]="'phone'" [control]="form.get('candidate.phone')" [type]="'input'" [label]="t('common.labels.mobile')" [edit]="inEdit" [basevalue]="order.phone"></app-form-control>
        </div>
      </div>

      <hr>

      <h2>{{ t('common.labels.hiringmanager') }}</h2>
      <div class="p-grid p-fluid">
        <div class="p-col-12 p-md-4">
          <app-form-control [cid]="'gender'" [control]="form.get('hiringmanager.gender')" [type]="'select'" [options]="optionsSalutations" [label]="t('common.labels.salutation')" [edit]="inEdit" [basevalue]="(order.orderer_gender) ? t('common.labels.' + order.orderer_gender) : '-'"></app-form-control>
        </div>
        <div class="p-col-12 p-md-4">
          <app-form-control [cid]="'firstname'" [control]="form.get('hiringmanager.firstname')" [type]="'input'" [label]="t('common.labels.firstname')" [edit]="inEdit" [basevalue]="order.orderer_firstname"></app-form-control>
        </div>
        <div class="p-col-12 p-md-4">
          <app-form-control [cid]="'lastname'" [control]="form.get('hiringmanager.lastname')" [type]="'input'" [label]="t('common.labels.lastname')" [edit]="inEdit" [basevalue]="order.orderer_lastname"></app-form-control>
        </div>
        <div class="p-col-12 p-md-4">
          <app-form-control [cid]="'email'" [control]="form.get('hiringmanager.email')" [type]="'input'" [label]="t('common.labels.email')" [edit]="inEdit" [basevalue]="order.orderer_email"></app-form-control>
        </div>
        <div class="p-col-12 p-md-4">
          <app-form-control [cid]="'phone'" [control]="form.get('hiringmanager.phone')" [type]="'input'" [label]="t('common.labels.phone')" [edit]="inEdit" [basevalue]="order.orderer_phone"></app-form-control>
        </div>
        <div class="p-col-12 p-md-4">
          <app-form-control [cid]="'mobile'" [control]="form.get('hiringmanager.mobile')" [type]="'input'" [label]="t('common.labels.mobile')" [edit]="inEdit" [basevalue]="order.orderer_mobile"></app-form-control>
        </div>
      </div>

      <hr>

      <h2>{{ t('toolbox_candidate_basedata.report_recipient') }}</h2>
      <div class="p-grid p-fluid">
        <div class="p-col-12 p-md-4">
          <app-form-control [cid]="'type'" [control]="form.get('report.type')" [type]="'select'" [options]="optionsReporttypes" [label]="t('toolbox_candidate_basedata.recipient_type')" [edit]="inEdit" [basevalue]="t('toolbox_candidate_basedata.reportmodes.' + order.report_recipient_type)"></app-form-control>
        </div>
      </div>
      <div class="p-grid p-fluid" *ngIf="hasRecipient">
        <div class="p-col-12 p-md-4">
          <app-form-control [cid]="'gender'" [control]="form.get('report.gender')" [type]="'select'" [options]="optionsSalutations" [label]="t('common.labels.salutation')" [edit]="inEdit" [basevalue]="t('common.labels.salutation')" [edit]="inEdit" [basevalue]="(order.report_recipient_gender) ? t('common.labels.' + order.report_recipient_gender) : '-'"></app-form-control>
        </div>
        <div class="p-col-12 p-md-4">
          <app-form-control [cid]="'firstname'" [control]="form.get('report.firstname')" [type]="'input'" [label]="t('common.labels.firstname')" [edit]="inEdit" [basevalue]="order.report_recipient_firstname"></app-form-control>
        </div>
        <div class="p-col-12 p-md-4">
          <app-form-control [cid]="'lastname'" [control]="form.get('report.lastname')" [type]="'input'" [label]="t('common.labels.lastname')" [edit]="inEdit" [basevalue]="order.report_recipient_lastname"></app-form-control>
        </div>
        <div class="p-col-12 p-md-4">
          <app-form-control [cid]="'recipient'" [control]="form.get('report.email')" [type]="'input'" [label]="t('common.labels.email')" [edit]="inEdit" [basevalue]="order.report_recipient_email"></app-form-control>
        </div>
      </div>

    </ng-container>

  </form>

</ng-container>
